/**
 * Header Component
 *
 * Application header with Dembrane logo and page title.
 * Features:
 * - Dembrane logo (left) linking to dembrane.com
 * - Page title (right)
 */

import { COLORS, EXTERNAL_LINKS } from '../../lib/constants';

const styles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px',
    backgroundColor: COLORS.parchment,
    borderBottom: `1px solid ${COLORS.graphite}20`,
  } as React.CSSProperties,
  logoLink: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  } as React.CSSProperties,
  logo: {
    height: '32px',
    width: 'auto',
  } as React.CSSProperties,
  title: {
    fontSize: '21px',
    fontWeight: 300,
    color: COLORS.graphite,
    margin: 0,
    paddingBottom: '2px',
    letterSpacing: '-0.01em',
  } as React.CSSProperties,
};

export function Header() {
  return (
    <header style={styles.header}>
      <a
        href={EXTERNAL_LINKS.dembrane}
        target="_blank"
        rel="noopener noreferrer"
        style={styles.logoLink}
        aria-label="Dembrane homepage"
      >
        <img
          src="/logos/dembrane-logo.svg"
          alt="Dembrane"
          style={styles.logo}
        />
      </a>
      <h1 style={styles.title}>Kaart van mensenkennis</h1>
    </header>
  );
}
